import { Button, Stack, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import { useDynamicPagesContext } from "../../../../context/dynamic-pages-context";

const AddTypesForm = () => {
  const [data, setData] = useState({
    title: "",
    description: "",
  });

  const { addTypes } = useDynamicPagesContext();

  const handleUpdate = async () => {
    if (!data.title.trim()) {
      alert("Title is required");
      return;
    }

    if (!data.description.trim()) {
      alert("Description is required");
      return;
    }

    const response = await addTypes(data);

    console.log(response, "response");
  };

  return (
    <Stack spacing={2} width={400}>
      <TextField
        fullWidth
        value={data.title}
        label="Title"
        onChange={(e) =>
          setData({
            ...data,
            title: e.target.value,
          })
        }
        variant="outlined"
        required
      />
      <small>
        *note : for now adding new page will not work .
      </small>

      <TextField
        required
        fullWidth
        value={data.description}
        label="Description"
        variant="outlined"
        multiline
        rows={4}
        onChange={(e) =>
          setData({
            ...data,
            description: e.target.value,
          })
        }
      />
      <small>
        *note : this description is not shown anywhere , its just for admin
      </small>
      <Button onClick={handleUpdate} variant="contained" color="primary">
        Submit
      </Button>
    </Stack>
  );
};

export default AddTypesForm;
